import { createContext, useContext } from 'react'

export type ToastTone = 'success' | 'error'
export type ToastInput = {
  message: string
  tone?: ToastTone
  actionLabel?: string
  onAction?: () => void
  durationMs?: number
}
export type ToastContextValue = { showToast: (input: ToastInput) => string; dismissToast: (id: string) => void }

export const ToastContext = createContext<ToastContextValue | null>(null)

export function useToast(): ToastContextValue {
  const value = useContext(ToastContext)
  if (!value) throw new Error('useToast doit être utilisé dans ToastProvider.')
  return value
}
